import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { DashboardSettingsTab } from '@features/dashboard'
import { useDashboardState } from '@features/dashboard'
import { ProfileAccountBanner } from './components/ProfileAccountBanner'
import { ProfileLegacySurface } from './components/ProfileLegacySurface'
import { ProfileMembershipHero } from './components/ProfileMembershipHero'
import { SettingsTabPanels } from './components/SettingsTabPanels'
import { SettingsTabs } from './components/SettingsTabs'
import './profile-layout.css'

export function SettingsScreen() {
  const { t } = useTranslation('translation')
  const { actions, state } = useDashboardState()
  const [selectedTabValue, setSelectedTabValue] = useState<DashboardSettingsTab>(
    state.settingsTab ?? 'account',
  )
  const tabValue = state.settingsTab ?? selectedTabValue

  useEffect(() => {
    if (!state.settingsTab) {
      return
    }

    actions.setSettingsTab(null)
  }, [actions, state.settingsTab])

  if (!state.myUser) {
    return null
  }

  return (
    <div className="profileStack">
      <div className="settingsLayout">
        <SettingsTabs onChange={setSelectedTabValue} t={t} value={tabValue} />

        <div className="settingsMainColumn">
          <ProfileAccountBanner
            addon={<ProfileMembershipHero profile={state.myUser} />}
            profile={state.myUser}
          />

          <ProfileLegacySurface padded={false}>
            <div
              aria-labelledby={`settings-tab-${tabValue}`}
              className="profilePanelPadding"
              id="settings-tab-panel"
              role="tabpanel"
            >
              <SettingsTabPanels
                onAvatarUploaded={(imageUrl) => {
                  actions.mergeMyUser({ imageUrl })
                }}
                onBuyKey={() => {
                  actions.setSelectPremiumAccountPayment(true)
                }}
                onEnterKey={() => {
                  actions.setEnterKeyPremium(true)
                }}
                onProfileSaved={(patch) => {
                  actions.mergeMyUser(patch)
                }}
                profile={state.myUser}
                value={tabValue}
              />
            </div>
          </ProfileLegacySurface>
        </div>
      </div>
    </div>
  )
}
